import React from "react";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Step, Stepper, StepButton } from 'material-ui/Stepper';

export default class StepperResponsivo3  extends React.Component { 
    state = {
        stepIndex: 2
    }

    render() {
        const { stepIndex } = this.state;
        return <div className="flex layout-gt-md-row layout-md-row layout-xs-column layout-sm-column layout-align-center-center">
            <MuiThemeProvider>
                <Stepper activeStep={stepIndex} linear={false} orientation="vertical">
                    <Step>
                        <StepButton id="colorDes" onClick={() => this.setState({ stepIndex: 0 })}>
                            PÓLIZA
                        </StepButton>
                    </Step>
                    <Step>
                        <StepButton id="colorDes" onClick={() => this.setState({ stepIndex: 1 })}>
                            CONTACTO
                        </StepButton>
                    </Step>
                    <Step>
                        <StepButton id="color" onClick={() => this.setState({ stepIndex: 2 })}>
                            SEGURIDAD
                        </StepButton>
                    </Step>
                </Stepper>
            </MuiThemeProvider>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/stepper-gnp-registro/stepper-responsivo3.cmpt.js